import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { useEffect } from 'react';
import { Provider as ReduxProvider } from 'react-redux';

import { MotionLazy } from '@components/Animate/MotionLazy';
import { AppInitializer } from '@components/AppInitializer';
import { SettingsProvider, defaultSettings } from '@components/settings';
import { Snackbar } from '@components/snackbar';
import 'simplebar-react/dist/simplebar.min.css';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import 'src/global.css';
import 'yet-another-react-lightbox/plugins/captions.css';
import 'yet-another-react-lightbox/plugins/thumbnails.css';
import 'yet-another-react-lightbox/styles.css';

import { configureBaseURLAxios } from '@src/api/axios';
import { getHostWithPrefix, isHostValid } from '@utils/url';

import { store } from '@redux/store';

import Router from './routes';
import { AuthProvider } from './routes/Auth/authContext';
import { ThemeProvider } from './theme';

if (!isHostValid()) {
  window.location.href = getHostWithPrefix(import.meta.env.VITE_APP_DOMAIN);
}

export default function App() {
  useEffect(() => {
    configureBaseURLAxios();
  }, []);

  return (
    <MotionLazy>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <ReduxProvider store={store}>
          <AuthProvider>
            <AppInitializer>
              <SettingsProvider defaultSettings={defaultSettings}>
                <ThemeProvider defaultMode="light" modeStorageKey="theme-mode">
                  <Snackbar />
                  <Router />
                </ThemeProvider>
              </SettingsProvider>
            </AppInitializer>
          </AuthProvider>
        </ReduxProvider>
      </LocalizationProvider>
    </MotionLazy>
  );
}
